import { all } from "redux-saga/effects";
import {
  watchCheckTokenLogin,
  watchLogin,
} from "shared-components/src/components/login/saga/auth.saga";
import watchMe from "shared-components/src/components/users/saga/users.saga";
import { watchGetWeatherCondition } from "shared-components/src/components/weatherForecast/saga/weatherForecast.saga";
import { watchAddActivity, watchGetActivity } from "./sagas/activities.saga";
import watchGetFarm from "./sagas/farm.saga";
import { watchAddFertilizer, watchDeleteFertilizer } from "./sagas/fertilizers.saga";
import {
  watchAddField,
  watchDeleteField,
  watchGetFields,
  watchUpdateField,
} from "./sagas/fields.saga";
import { watchAddIrrigation, watchDeleteIrrigation } from "./sagas/irrigations.saga";
import { watchAddPesticide, watchDeletePesticide } from "./sagas/pesticides.saga";
import { watchGetSensorsMeasure } from "./sagas/realtime.saga";
import { watchGetSensorMeasureData } from "./sagas/realtimeSensorMeasure.saga";
import {
  watchAddCommandSensor,
  watchAddSensor,
  watchDeleteSensor,
  watchFetchCommandSensor,
  watchUpdateSensor,
} from "./sagas/sensors.saga";
import { watchAddSoilPreparation, watchDeleteSoilPreparation } from "./sagas/soilPreparations.saga";

export default function* rootSaga() {
  yield all([
    watchLogin(),
    watchCheckTokenLogin(),
    watchMe(),
    watchGetFarm(),
    watchGetFields(),
    watchAddField(),
    watchUpdateField(),
    watchDeleteField(),
    watchAddSensor(),
    watchDeleteSensor(),
    watchGetActivity(),
    watchAddActivity(),
    watchAddIrrigation(),
    watchDeleteIrrigation(),
    watchAddSoilPreparation(),
    watchDeleteSoilPreparation(),
    watchAddFertilizer(),
    watchDeleteFertilizer(),
    watchAddPesticide(),
    watchDeletePesticide(),
    watchGetSensorsMeasure(),
    watchGetSensorMeasureData(),
    watchAddCommandSensor(),
    watchFetchCommandSensor(),
    watchGetWeatherCondition(),
    watchUpdateSensor(),
  ]);
}
